import React from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import GoogleMapsMarkerSizeEnum from "../../../models/Google Maps/GoogleMapsMarkerSizeEnum";
import IClient from "../../../models/IClient";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./UseClientAddressModal.scss";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    orderModel: IOrder;
    clientModel: IClient;
    useClientAddressFn: (useClientAddress: boolean) => void;
};

const UseClientAddressModal: React.FC<Props> = (props) => {
    return (
        <div className={"UseClientAddressModal p-2"}>
            <div className={"w-100"} style={{ height: "2rem" }}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-user"} title={"use_client_address"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                    </div>
                </div>
            </div>

            <div className={"d-flex mt-4"}>
                <div className={"me-2"}>
                    <OwLabel title={"order_ship_to"} isBold={true} isUnderline={true} />
                    <div className={""}>
                        <AddressDisplay address={props.orderModel.Ship_To} />
                        {props.orderModel.Ship_To ? (
                            <OwGoogleStaticMap
                                address={props.orderModel.Ship_To}
                                className={"mt-2"}
                                size={"150x150"}
                                markerSize={GoogleMapsMarkerSizeEnum.SMALL}
                            />
                        ) : null}
                    </div>
                </div>

                <div className={"ms-2"}>
                    <OwLabel title={"client_ship_to"} isBold={true} isUnderline={true} />
                    <div className={""}>
                        <AddressDisplay address={props.clientModel.Ship_To} />
                        {props.clientModel.Ship_To ? (
                            <OwGoogleStaticMap
                                address={props.clientModel.Ship_To}
                                className={"mt-2"}
                                size={"150x150"}
                                markerSize={GoogleMapsMarkerSizeEnum.SMALL}
                            />
                        ) : null}
                    </div>
                </div>
            </div>

            <div className={"mt-4 d-flex align-items-center"}>
                <div>
                    <OwButton
                        title={"yes"}
                        fn={() => {
                            props.useClientAddressFn(true);
                        }}
                    />
                </div>
                <div className={"ms-2"}>
                    <OwButton
                        title={"no"}
                        className={"btn-danger"}
                        fn={() => {
                            props.useClientAddressFn(false);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default UseClientAddressModal;
